export const initialUserLogsState = {
    messageLogsByUserId: {},
    httpLogsByUserId: {},
};
